import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "@/lib/api";
import { AdminTitle, Pill } from "@/admin/AdminLayout";
import { ContentTally } from "@/admin/ContentTally";
import { ActivityFeed } from "@/admin/ActivityFeed";

export default function AdminDashboard() {
  const [s, setS] = useState<any>(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const cards = [["Revenue (paid)", money(s.revenue), "/admin/orders"], ["Paid orders", s.orders, "/admin/orders"], ["Live products", `${s.products_live} / ${s.products_total}`, "/admin/products"],
    ["Pending reviews", s.pending_reviews, "/admin/reviews"], ["Consultation requests", s.consultations, "/admin/inbox"], ["Customers", s.customers, "/admin"]];
  const ls = s.last_sync;
  return (
    <div data-testid="admin-dashboard">
      <AdminTitle title="Dashboard" sub="Store overview" />
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {cards.map(([l, v, to]: any) => (
          <Link key={l} to={to} className="bg-white border border-neutral-200 p-6 hover:border-neutral-900 transition-colors" data-testid={`stat-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <p className="eyebrow text-[10px] text-neutral-500">{l}</p><p className="font-display text-4xl mt-3">{v}</p>
          </Link>
        ))}
      </div>
      <div className="bg-white border border-neutral-200 p-6 mt-6" data-testid="dashboard-last-sync">
        <p className="eyebrow text-[10px] text-neutral-500 mb-3">Last lookbook sync</p>
        {ls ? (
          <div className="flex flex-wrap items-center gap-4 text-sm">
            <Pill tone={ls.status === "success" ? "green" : ls.status === "failed" ? "red" : "amber"}>{ls.status}</Pill>
            <span>{new Date(ls.started_at).toLocaleString("en-AU")}</span><span className="text-neutral-500">{ls.trigger}</span>
            <span>{ls.counts.fetched} fetched · {ls.counts.created} new · {ls.counts.updated} updated · {ls.counts.archived} archived · {ls.counts.skipped} skipped</span>
            <Link to="/admin/sync" className="underline">Details</Link>
          </div>
        ) : <p className="text-sm">No sync has run yet.</p>}
      </div>
      <ContentTally />
      <ActivityFeed />
    </div>
  );
}
